module.exports = __webpack_public_path__ + "media/images/instructions/2-f7514e0726771963a8f027ff64562bbe.png";